import { Slider as BaseSlider } from "@base-ui/react/slider";
import clsx from "clsx";
import PropTypes from "prop-types";
import * as React from "react";
import css from "./Slider.module.css";

const Slider = React.forwardRef(
  (
    {
      value,
      defaultValue,
      onValueChange,
      onValueCommitted,
      min = 0,
      max = 100,
      step = 1,
      largeStep,
      orientation = "horizontal",
      disabled = false,
      label,
      name,
      className,
      ...rest
    },
    ref,
  ) => (
    <BaseSlider.Root
      ref={ref}
      className={clsx(css.root, className)}
      value={value}
      defaultValue={defaultValue}
      onValueChange={onValueChange}
      onValueCommitted={onValueCommitted}
      min={min}
      max={max}
      step={step}
      largeStep={largeStep}
      orientation={orientation}
      disabled={disabled}
      name={name}
      {...rest}
    >
      {label && (
        <BaseSlider.Label className={css.label}>{label}</BaseSlider.Label>
      )}
      <BaseSlider.Control className={css.control}>
        <BaseSlider.Track className={css.track}>
          <BaseSlider.Indicator className={css.indicator} />
          <BaseSlider.Thumb className={css.thumb} />
        </BaseSlider.Track>
      </BaseSlider.Control>
    </BaseSlider.Root>
  ),
);

Slider.displayName = "Slider";

Slider.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.arrayOf(PropTypes.number),
  ]),
  defaultValue: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.arrayOf(PropTypes.number),
  ]),
  onValueChange: PropTypes.func,
  onValueCommitted: PropTypes.func,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  largeStep: PropTypes.number,
  orientation: PropTypes.oneOf(["horizontal", "vertical"]),
  disabled: PropTypes.bool,
  label: PropTypes.string,
  name: PropTypes.string,
  className: PropTypes.string,
};

export default Slider;
